import { render, staticRenderFns } from "./Item2min.vue?vue&type=template&id=8bcb45c2&scoped=true&"
import script from "./Item2min.vue?vue&type=script&lang=js&"
export * from "./Item2min.vue?vue&type=script&lang=js&"
import style0 from "./Item2min.vue?vue&type=style&index=0&id=8bcb45c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bcb45c2",
  null
  
)

export default component.exports